// Garante que a autenticação esteja disponível para toda a aplicação.
// Utilizado no App.tsx para fornecer contexto de autenticação globalmente.

import React from 'react';
import JwtAuthProvider from '../auth/services/jwt/JwtAuthProvider';

// Envolve os filhos do componente (children) no JwtAuthProvider.
const Authentication = ({ children }: { children: React.ReactNode }) => {
	return (
		<JwtAuthProvider>
			{children}
		</JwtAuthProvider>
	);
};

export default Authentication;
